import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'components/base/Button';

import FirstIconEnabled from '../../assets/images/pagination-images/left-arrow-First.svg';
import FirstIconDisabled from '../../assets/images/pagination-images/angles-left-regular.svg';
import LastIconEnabled from '../../assets/images/pagination-images/right-arrow-Last.svg';
import LastIconDisabled from '../../assets/images/pagination-images/angles-right-regular.svg';


import RightVector from '../../assets/images/account-page/angle-right-regular.svg';
import LeftVector from '../../assets/images/account-page/angle-left-regular.svg';

import css from './style.scss';

class PageButton extends PureComponent {
  handleClick = (e) => {
    const { onClick, disabled, page } = this.props;
    e.preventDefault();
    if (!disabled) onClick(page);
  };

  renderLabel() {
    const { first, previous, next, last, disabled } = this.props;

    // First button
    if (first) {
      const icon = disabled ? FirstIconDisabled : FirstIconEnabled;
      return <img src={icon} alt="First" className={classNames(css.icons, disabled && css.iconDisabled)} />;
    }

    // Last button
    if (last) {
      const icon = disabled ? LastIconDisabled : LastIconEnabled;
      return <img src={icon} alt="Last" className={classNames(css.icons, disabled && css.iconDisabled)} />;
    }

    // Previous/Next buttons (using same icons)
    if (previous || next) {
      const isPrev = !!previous;
      const spanClass = classNames(
        css.iconButton,
        isPrev ? css.previous : css.next,
        disabled && css.iconButtonDisabled
      );

      return (
        <span className={spanClass}>
          <img
            src={isPrev ? LeftVector : RightVector}
            alt={isPrev ? 'Previous' : 'Next'}
            className={classNames(css.icon, disabled && css.iconDisabled)}
          />
        </span>
      );
    }

    return this.props.page;
  }

  render() {
    const { disabled, first, last } = this.props;
    const isOuter = first || last;

    const className = classNames(css.button, {
      [css.disabled]: disabled,
      [css.outerIconBtn]: isOuter,
      [css.innerCircleBtn]: !isOuter,
      [css.firstBtn]: first,
      [css.lastBtn]: last,
    });

    return (
      <Button
        kind={Button.kind.blueGhost}
        className={className}
        onClick={this.handleClick}
        disabled={disabled}
      >
        {this.renderLabel()}
      </Button>
    );
  }
}

PageButton.propTypes = {
  hide: PropTypes.bool,
  disabled: PropTypes.bool,
  first: PropTypes.bool,
  last: PropTypes.bool,
  previous: PropTypes.bool,
  next: PropTypes.bool,
  page: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PageButton;
